//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IDraftInstagramPost } from '@apis/universal-posts/draft-posts/universalDraftPostsApiModel';
import { IInstagramDraftsModalState } from '@instagram-account/redux/drafts/modal/instagramDraftsModalModel';
import DraftId from '@models/DraftId';
import { Normalized } from '@utils/normalize';

export enum INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS {
  REQUEST_DRAFTS = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/REQUEST_DRAFTS',
  RECEIVE_DRAFTS_SUCCEEDED = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/REQUEST_DRAFTS_SUCCEEDED',
  RECEIVE_DRAFTS_FAILED = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/REQUEST_DRAFTS_FAILED',

  REQUEST_SAVE_DRAFT = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/REQUEST_SAVE_DRAFT',
  RECEIVE_SAVE_DRAFT_SUCCEEDED = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/RECEIVE_SAVE_DRAFT_SUCCEEDED',
  RECEIVE_SAVE_DRAFT_FAILED = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/RECEIVE_SAVE_DRAFT_FAILED',

  REQUEST_DELETE_DRAFT = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/REQUEST_DELETE_DRAFT',
  RECEIVE_DELETE_DRAFT_SUCCEEDED = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/RECEIVE_DELETE_DRAFT_SUCCEEDED',
  RECEIVE_DELETE_DRAFT_FAILED = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/RECEIVE_DELETE_DRAFT_FAILED',

  REQUEST_SWAP_DRAFT_STATUS = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/REQUEST_SWAP_DRAFT_STATUS',
  RECEIVE_SWAP_DRAFT_STATUS_SUCCEEDED = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/REQUEST_SWAP_DRAFT_STATUS_SUCCEEDED',
  RECEIVE_SWAP_DRAFT_STATUS_FAILED = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/REQUEST_SWAP_DRAFT_STATUS_FAILED',

  CLEAR_SWAP_STATUS_ERROR = 'INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS/CLEAR_SWAP_STATUS_ERROR',
}

export interface ICombinedInstagramDraftsState
  extends IInstagramAccountDraftsState {
  modal: IInstagramDraftsModalState;
}

export interface IInstagramAccountDraftsState {
  draftPosts?: Normalized<IDraftInstagramPost, DraftId>;
  fetchDraftsError?: string;
  saveDraftError?: string;
  deleteDraftError?: string;
  flags: IInstagramAccountDraftsFlags;
  swapDraftStatusError?: string;
}

interface IInstagramAccountDraftsFlags {
  hasFetchedDrafts: boolean;
  isFetchingDrafts: boolean;
  isSavingDraft: boolean;
  isDeletingDraft: boolean;
  isSwappingDraftStatus: boolean;
}
